import React from 'react';

const PrimaryButton = () => {
    return (
        <button className="btn btn-primary bg-gradient-to-r from-primary to-secondary text-white  ">
        Get Started
      </button>
    );
};

export default PrimaryButton;